import React from 'react';
import '../css/home.css';
import maukhonglogocosan from '../../src/images/maukhonglogocosan.png';
import nologo1 from '../../src/images/nologo1.png';
import nologo2 from '../../src/images/nologo2.png';
import nologo3 from '../../src/images/nologo3.jpg';
import nologo4 from '../../src/images/nologo4.jpg';
import nologo5 from '../../src/images/nologo5.jpg';
import nologo6 from '../../src/images/nologo6.jpg';
import nologo7 from '../../src/images/nologo7.jpg';
import nologo8 from '../../src/images/nologo8.jpg';
import nologo9 from '../../src/images/nologo9.jpg';
import nologo10 from '../../src/images/nologo10.jpg';
import TButtonAdvise from "./TButtonAdvise";
import { Link } from "react-router-dom";

const ModalNoLogoDesktop = () => {

    return (<div id="myModalNoLogo" className="modal--thanghn">
        <div className="modal-content--thanghn4" style={{height:650}}>
            <div style={{display: 'flex', flex: 1, gap: 10, flexDirection: 'column', position: 'relative'}}>
                <div style={{padding: 20, display: 'flex', flexDirection: 'row', flex: 1, backgroundColor: '#061F4D'}}>
                    <img src={maukhonglogocosan} style={{
                        height: 160, width: 'auto', backgroundColor: 'white', borderRadius: 10, overflow: 'hidden'
                    }}/>
                    <div style={{
                        marginLeft: 20, display: 'flex', flexDirection: 'column', flex: 3, alignItems: 'start',
                    }}>
                        <h3 style={{color: 'white', fontWeight: 'bold'}}>Mẫu không logo có sẵn</h3>
                        <p style={{color: 'white', textAlign: 'left'}}>CHFootball cung cấp các sản phẩm các thương hiệu
                            Việt Nam như Kamito, Bulbal, Riki, CP, Wika.... với nhiều mẫu mã, chất liệu đa dạng.</p>
                        <div style={{ display: "flex", flexDirection: 'row', columnGap: 4 }}>
                            <TButtonAdvise />
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'white', height: 40, padding: 10, borderRadius: 10 }}>
                                <Link to="/maukhonglogo"
                                // target={"_blank"} 
                                style={{ margin: 0, padding: 0 }}><span style={{ color: 'black', fontSize: 14, margin: 0, padding: 0, fontWeight: 'bold' }}>Xem thêm</span>
                                </Link>
                            </div>
                        </div>
                        
                    </div>
                    <span style={{paddingRight: 5, paddingLeft: 5, position: 'absolute', top: 0, right: 10}}
                          className="close" onClick={() => {
                        var modal = document.getElementById("myModalNoLogo");
                        modal.style.display = "none";
                    }}>&times;</span>
                </div>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <div style={{display: 'flex', flexDirection: 'row', gap: 20, justifyContent: 'center'}}>
                        <img src={nologo1} style={{width: 190.521, height: 253.773}}/>
                        <img src={nologo2} style={{width: 190.521, height: 253.773}}/>
                        <img src={nologo3} style={{width: 190.521, height: 253.773}}/>
                        <img src={nologo4} style={{width: 190.521, height: 253.773}}/>
                    </div>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', gap: 20, justifyContent: 'center'}}>
                    <img src={nologo5} style={{width: 190.521, height: 253.773}}/>
                    <img src={nologo6} style={{width: 190.521, height: 253.773}}/>
                    <img src={nologo7} style={{width: 190.521, height: 253.773}}/>
                    <img src={nologo8} style={{width: 190.521, height: 253.773}}/>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', gap: 20, justifyContent: 'center', marginBottom:10}}>
                    <img src={nologo9} style={{width: 190.521, height: 253.773}}/>
                    <img src={nologo10} style={{width: 190.521, height: 253.773}}/>
                    <div style={{width: 190.521, height: 253.773}}/>
                    <div src={nologo4} style={{width: 190.521, height: 253.773}}/>
                </div>
            </div>
        </div>
    </div>)
}

export default React.memo(ModalNoLogoDesktop);
